import styled from "styled-components";

const Description = styled.p`
  line-height: 2em;
  letter-spacing: 0.2em;
  @media screen and (max-width: 960px) {
    text-align: left;
    margin-bottom: 20px;
  }
  @media screen and (min-width: 961px) {
    text-align: center;
    margin: 0 auto 50px;
    max-width: 900px;
  }
  
  & a {
    color: white;
    text-decoration: underline;
  }
`;
export default Description;
